import { render } from "./our-teams.vue?vue&type=template&id=0df4aecc"
import script from "./our-teams.vue?vue&type=script&lang=js"
export * from "./our-teams.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__